import { AdminLayout } from '../AdminLayout';
import { AdminEmailTemplates } from './AdminEmailTemplates';
import AdminEmailHistory from './AdminEmailHistory';
import { AdminEmailLists } from './AdminEmailLists';
import { useUrlTabState } from '../../hooks/useUrlTabState';

type AdminEmailTab = 'templates' | 'history' | 'lists';
const EMAIL_TABS: readonly AdminEmailTab[] = ['history', 'templates', 'lists'];

export function AdminEmail() {
  const [activeSubTab, setActiveSubTab] = useUrlTabState<AdminEmailTab>('tab', EMAIL_TABS, 'history');

  return (
    <AdminLayout>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg lg:flex lg:flex-col lg:flex-1 lg:min-h-0">
        <div className="border-b border-gray-200 flex-shrink-0">
          <nav className="-mb-px flex overflow-x-auto">
            <button
              className={`whitespace-nowrap py-4 px-3 sm:px-6 text-sm font-medium ${
                activeSubTab === 'history'
                  ? 'border-b-2 border-blue-500 text-blue-600'
                  : 'border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
              onClick={() => setActiveSubTab('history')}
            >
              Email History
            </button>
            <button
              className={`whitespace-nowrap py-4 px-3 sm:px-6 text-sm font-medium ${
                activeSubTab === 'templates'
                  ? 'border-b-2 border-blue-500 text-blue-600'
                  : 'border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
              onClick={() => setActiveSubTab('templates')}
            >
              Email Templates
            </button>
            <button
              className={`whitespace-nowrap py-4 px-3 sm:px-6 text-sm font-medium ${
                activeSubTab === 'lists'
                  ? 'border-b-2 border-blue-500 text-blue-600'
                  : 'border-b-2 border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
              onClick={() => setActiveSubTab('lists')}
            >
              Email Lists
            </button>
          </nav>
        </div>

        {activeSubTab === 'templates' && (
          <AdminEmailTemplates />
        )}

        {activeSubTab === 'history' && (
          <AdminEmailHistory />
        )}

        {activeSubTab === 'lists' && (
          <AdminEmailLists />
        )}
      </div>
    </AdminLayout>
  );
}
